export const PAYMENT_CARD_EXPIRY_DATE_COUNT = 30
export const FALLBACK_TIMEZONE = 'Asia/Taipei'

export const COMMON_DEFAULT_COUNTRY_CODE = 'TW'
export const ELITE_DEFAULT_COUNTRY_CODE = 'MY'
